import {HttpResponse, HttpService} from "./http.service";
import {NotificationModel} from "../models/notification.model";
import {PaginationModel} from "../models/pagination.model";

export const NotificationService = {
    async getNotifications(page: number = 0, perPage: number = -1): Promise<PaginationModel<NotificationModel[]>> {
        const offset = page * perPage;
        const limit = perPage;

        const response: HttpResponse<PaginationModel<NotificationModel[]>> = await HttpService.get(`notification/?offset=${offset}&limit=${limit}`);

        return response.data;
    },
    async getGlobalUnread(): Promise<{unread_amount: number}> {
        const response: HttpResponse<Promise<{unread_amount: number}>> =  await HttpService.get('notification/global_unreads/');

        return response.data;
    },
    async setGlobalRead() {
        return await HttpService.patch('notification/global_read/', {});
    },
    async setNotificationRead(id: number) {
        return await HttpService.patch(`notification/${id}/read/`, {});

    }
}
